import $ from 'jquery';
import formatDate from '../../../common/DateFormate';

// export const UserTableData = {
//   	tableId : 'users_table',
//   	ajaxUrl : 'admin/users',
//   	columns : [
//     { data: 'first_name', title: 'Name' },
//     { data: 'email', title: 'Email' },
//     { data: 'phone', title: 'Phone' },
//     { data: 'brand_name', title: 'Brand' },
//     { data: 'created_at', title: 'Created At' }
//   ]
// };

export const MarketPlaceAccountsTableData = {
  tableId: 'marketplace_accounts_table',
  tableIdParams:'marketplace-id',
  ajaxUrl: 'api/v1/marketplace_accounts',
  columns:  [
    { data: 'name', title:"Name"  },
    { data: 'marketplace', title :"Marketplace"  },
    { data: 'external_id', title :"External Id"  },
    { data: 'active', title :"Active"  },
    { data: 'last_sync', title :"Last Sync"  },
    { data: 'actions', title :"Actions", orderable: false, searchable: false }
  ]
};


export const ReportProcessingsTableData = {
  tableId: 'report_processings_table',
  tableIdParams:'report_processing_id',
  ajaxUrl: 'api/v1/report_processings',
  columns: [
    { data: "report_definition", title:"Report Definition" },
    { data: "file_format", title:"File Format" },
    { data: "status", title:"Status" },
    { data: "report_period_type", title:"Report Period Type" },
    { data: "marketplace_account", title:"Marketplace Account" },
    { data: "downloaded_at", title:"Downloaded At" },
    { data: "processed_at", title:"Processed At" },
    { data: "actions", title:"Actions", orderable: false, searchable: false }
  ],
};

export const ordersTableData = {
  tableId: 'orders_table',
  ajaxUrl: 'api/v1/orders',
  ajaxMethodType:'POST',
  columns: [
    { data: "product_id",                 title: "Product" },
    // { data: "marketplace_account_id",     title: "Marketplace Account" },
    { data: "total_sale_amount",          title: "Total Sale Amount" },
    { data: "total_net_sale_amount",      title: "Total Net Sale Amount" },
    { data: "is_business_order",          title: "B2B/B2C" },
    { data: "external_order_id",          title: "Order ID" },
    { data: "status",                     title: "Status" },
    { data: "fulfillment_channel",        title: "Fulfillment Channel" },
    { data: "currency",                   title: "Currency" },
    { data: "quantity",                   title: "Quantity" },
    { data: "purchase_at",                title: "Purchase Date & Time" },
    { data: "refund",                     title: "Refund" },
    { data: "product_price",              title: "Product Price" },
    { data: "payment_mode",               title: "Payment Mode" },
    { data: "sku",                        title: "SKU" },
    { data: "asin",                       title: "ASIN" },
    { data: "actual_net_sale_amount",     title: "Actual Net Sale Amount" },
    { data: "promotion_amount",           title: "Promotion Amount" },
    { data: "refund_commission_fee",      title: "Refund Commission Fee" },
    { data: "replacement_order_id",       title: "Replacement Order ID" },
    { data: "replacement_quantity",       title: "Replacement Quantity" },
    { data: "return_at",                  title: "Return Date" },
    { data: "return_quantity",            title: "Return Quantity" },
    { data: "fba_pick_pack",              title: "FBA Pick & Pack" },
    { data: "fba_shipment_fees",          title: "FBA Shipment Fees" },
    { data: "fba_shipment_fees_reversal", title: "FBA Shipment Fees Reversal" },
    { data: "easy_ship_fees",             title: "Easy Ship Fees" },
    { data: "shipping_commission",        title: "Shipping Commission" },
    { data: "closing_commission",         title: "Closing Commission" },
    { data: "referral_commission",        title: "Referral Commission" },
    { data: "technology_commission",      title: "Technology Commission" },
    { data: "storage_commission",         title: "Storage Commission" },
    { data: "refund_commission",          title: "Refund Commission" },
    { data: "tcs",                        title: "TCS" },
    { data: "tds",                        title: "TDS" },
    { data: "removal_charge",             title: "Removal Charge" },
    { data: "tax",                        title: "Tax" },
    { data: "incorrect_fee",              title: "Incorrect Fee" },
    { data: "cod",                        title: "COD" },
    { data: "product_tax_discount",       title: "Product Tax Discount" },
    // { data: "rejected_status",                title: "Rejected Status" },
    // { data: "returned_status",                title: "Returned Status" },
    // { data: "product_price_without_tax_discount", title: "Product Price Without Tax Discount" },
    // { data: "refund_product_price",           title: "Refund Product Price" },
    // { data: "easy_ship_fees_reversal",        title: "Easy Ship Fees Reversal" },
  ]
};

export const productsTableData = {
  tableId: 'products_table',
  ajaxUrl: 'api/v1/products',
  columns: [
    { data: "sku", title: "SKU"},
    { data: "asin", title: "ASIN"},
    { data: "title", title: "Title"},
    { data: "price", title: "Price"},
    { data: "mrp", title: "MRP"},
    { data: "marketplace_account_id", title: "Marketplace Account" },
    { data: "condition", title: "Condition" },
    { data: "fulfillment_channel", title: "Fulfillment Channel" },
    { data: "status", title: "Status"},
    { data: "quantity", title: "Quantity"},
    { data: "marketplace", title: "Marketplace"}
  ]
};

export const billingInvoiceTableData = {
  tableId: 'user-invoices',
  ajaxUrl: 'api/v1/invoices',
  columns: [
  { data: 'invoice_number',title: "Invoice Number",    render: function (data, type, row) {
      return `
        <span 
          class="invoice-number text-primary" 
          data-invoice-id="${row.id}" 
          style="cursor:pointer; text-decoration:underline;">
          ${data}
        </span>
      `;
    }, },
  { data: 'amount',title: "Amount"},
  { data: 'status' ,title: "Status"},
  { data: 'package_name',title: "Package Name"},
  { data: 'payment_method',title: "Payment Method" },
  { data: 'paid_at',title: "Paid At" },
  { data: 'created_at',title: "Created At" }
]
};


